module.exports = __webpack_public_path__ + "brovar_icon.png?56dfd315a689ee385801f5470ab1bdae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brovar_icon.png
// module id = 54
// module chunks = 0